import { ADDRESS_INFORMATION_API } from '../constants/AppConstants';

export default async () => {
  try {
    const response = await fetch(`${ADDRESS_INFORMATION_API}?addressType=ShipToAddress`);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
